import { DrawerBase } from '../../core/abstraction/DrawerBase';
import { getTranslation, translationKeys } from '../../core/translation/translation';
import { BALANCE_VALUE, BONUS_COST_AMOUNT, LAST_WIN_VALUE } from '../../stateManagment/gameState';
import { FONT_LATO_NAME } from '../../core/constats';
import { amountFormatter } from '../../core/helpers/amountFormatter';
import { partnerService } from '../../services/helperService/PartnerService';

export class BalanceLastWinDrawer extends DrawerBase {
    getContent({
        sizes: { w = 205, h = 80 } = {},
        position: { x = 0, y = 0 } = {},
        isBonus = false
    } = {}) {
        const rect = this.createGraphics()
            .drawRect(
                x,
                y,
                w,
                h,
            );

        const titleStyle = {
            fontFamily: FONT_LATO_NAME,
            fontSize: 20,
            fill: 0xe3c632,
            fontWeight: 900,
        };

        const valueStyle = {
            fontFamily: FONT_LATO_NAME,
            fontSize: 20,
            fill: 0xFFFFFF,
            fontWeight: 900,
        };

        const balanceContainer = this.createContainer('balanceContainer');
        const lastWinContainer = this.createContainer('lastWinContainer');
        const amountCostContainer = this.createContainer('amountCostContainer');

        const balanceTitle = new this.PIXI.Text(`${getTranslation(translationKeys.BALANCE)}: `, titleStyle);
        const lastWinTitle = new this.PIXI.Text(`${getTranslation(translationKeys.LAST_WIN)}: `, titleStyle);
        const amountTitle = new this.PIXI.Text(`${getTranslation(translationKeys.BET_AMOUNT)}: `, titleStyle);

        const balanceValue = new this.PIXI.Text('', valueStyle);
        const lastWinValue = new this.PIXI.Text('', valueStyle);
        const amountValue = new this.PIXI.Text('', valueStyle);

        this.setPosition(balanceTitle, { x: 15, y: 10 });
        this.setPosition(lastWinTitle, { x: 15, y: 40 });
        this.setPosition(amountTitle, { x: 15, y: 40 });
        this.setPosition(balanceValue, { x: 15 + balanceTitle.width, y: 10 });
        this.setPosition(lastWinValue, { x: 15 + lastWinTitle.width, y: 40 });
        this.setPosition(amountValue, { x: 15 + amountTitle.width, y: 40 });

        this.addSubscriber(BALANCE_VALUE.subscribe((value) => {
            balanceValue.text = `${amountFormatter.format(value)} ${partnerService.displayCurrency}`;
        }, true));
        this.addSubscriber(LAST_WIN_VALUE.subscribe((value) => {
            lastWinValue.text = `${amountFormatter.format(value)} ${partnerService.displayCurrency}`;
        }, true));
        this.addSubscriber(BONUS_COST_AMOUNT.subscribe((value) => {
            amountValue.text = `${amountFormatter.format(value)} ${partnerService.displayCurrency}`;
        }, true));

        balanceContainer.addChild(
            balanceTitle,
            balanceValue,
        );

        lastWinContainer.addChild(
            lastWinTitle,
            lastWinValue,
        );

        amountCostContainer.addChild(
            amountTitle,
            amountValue
        )

        if (isBonus) {
            amountCostContainer.visible = true;
            lastWinContainer.visible = false;
        } else {
            amountCostContainer.visible = false;
            lastWinContainer.visible = true;
        }

        rect.addChild(
            balanceContainer,
            lastWinContainer,
            amountCostContainer,
        );
        return rect;
    }
}

export const balanceLastWinDrawer = new BalanceLastWinDrawer();
